var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("table", { staticClass: "table bg-white table-bordered" }, [
    _c("tbody", [
      _c("tr", [
        _c("td", [_c("span", [_vm._v(_vm._s(_vm._f("trans")("Method")))])]),
        _vm._v(" "),
        _c("td", [_c("span", [_vm._v(_vm._s(this.response.method))])]),
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("td", [_c("span", [_vm._v(_vm._s(_vm._f("trans")("All")))])]),
        _vm._v(" "),
        _c("td", [_c("span", [_vm._v(_vm._s(this.factors.all))])]),
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("td", [_c("span", [_vm._v(_vm._s(_vm._f("trans")("Blue")))])]),
        _vm._v(" "),
        _c("td", [_c("span", [_vm._v(_vm._s(this.factors.blue))])]),
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("td", [_c("span", [_vm._v(_vm._s(_vm._f("trans")("Green")))])]),
        _vm._v(" "),
        _c("td", [_c("span", [_vm._v(_vm._s(this.factors.green))])]),
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("td", [_c("span", [_vm._v(_vm._s(_vm._f("trans")("Red")))])]),
        _vm._v(" "),
        _c("td", [_c("span", [_vm._v(_vm._s(this.factors.red))])]),
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("td", [
          _c("span", [
            _vm._v(_vm._s(_vm._f("trans")("Percentage Difference"))),
          ]),
        ]),
        _vm._v(" "),
        _c("td", [_c("span", [_vm._v(_vm._s(_vm.percentDiff) + "%")])]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }